export const GET_CONFIGURATIONS_REQUEST = 'GET_CONFIGURATIONS_REQUEST'
export const GET_CONFIGURATIONS = 'GET_CONFIGURATIONS'

export const GET_CONFIGURATION_REQUEST = 'GET_CONFIGURATION_REQUEST'
export const GET_CONFIGURATION = 'GET_CONFIGURATION'

export const UPDATE_CONFIGURATION_REQUEST = 'UPDATE_CONFIGURATION_REQUEST'
export const UPDATE_CONFIGURATION = 'UPDATE_CONFIGURATION'

export const CREATE_CONFIGURATION_REQUEST = 'CREATE_CONFIGURATION_REQUEST'
export const CREATE_CONFIGURATION = 'CREATE_CONFIGURATION'

export const DELETE_CONFIGURATION_REQUEST = 'DELETE_CONFIGURATION_REQUEST'
export const DELETE_CONFIGURATION = 'DELETE_CONFIGURATION'

export const TOGGLE_CONFIGURATION_STATUS_REQUEST = 'TOGGLE_CONFIGURATION_STATUS_REQUEST'
export const TOGGLE_CONFIGURATION_STATUS = 'TOGGLE_CONFIGURATION_STATUS'

export const GET_CONFIGURATIONS_REQUEST_PENDING = 'GET_CONFIGURATIONS_REQUEST_PENDING'
export const GET_CONFIGURATIONS_REQUEST_SUCCESS = 'GET_CONFIGURATIONS_REQUEST_SUCCESS'
export const GET_CONFIGURATIONS_REQUEST_ERROR = 'GET_CONFIGURATIONS_REQUEST_ERROR'

export const CHANGE_CONFIGURATIONS_REQUEST_PENDING = 'CHANGE_CONFIGURATIONS_REQUEST_PENDING'
export const CHANGE_CONFIGURATIONS_REQUEST_SUCCESS = 'CHANGE_CONFIGURATIONS_REQUEST_SUCCESS'
export const CHANGE_CONFIGURATIONS_REQUEST_ERROR = 'CHANGE_CONFIGURATIONS_REQUEST_ERROR'
